var React = require('react');

function ShareInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M55.5 48h-50c-.8 0-1.5-.7-1.5-1.5V13H1.5c-.7 0-1.4-.5-1.5-1.3s.3-1.4 1-1.7L30 0c.3-.1.7-.1 1 0l29 10c.7.2 1.1.9 1 1.7s-.8 1.3-1.5 1.3H57v33.5c0 .8-.7 1.5-1.5 1.5zM7 45h47V11.5v-.3L30.5 3.1 7 11.2V45z","key":0}),React.createElement("path",{"d":"M13.9 40.5c-.1 0-.1 0 0 0-.7 0-1.2-.4-1.4-1-.5-1.4-.7-2.8-.7-4.1 0-9.2 10.3-16.7 23.3-17.3v-6.8c0-.6.4-1.1.9-1.4.6-.2 1.2-.1 1.6.3l13.6 13.4c.3.3.4.7.4 1.1s-.2.8-.4 1.1L37.6 39.1c-.4.4-1.1.5-1.6.3-.6-.2-.9-.8-.9-1.4v-7.4c-9.7.6-17.7 4.2-19.8 9-.3.6-.8.9-1.4.9zm24.2-25.6v4.7c0 .8-.7 1.5-1.5 1.5-11.9 0-21.6 6.3-21.8 14 4.2-4.4 12.3-7.3 21.8-7.6.4 0 .8.1 1.1.4.3.3.5.7.5 1.1v5.4l9.9-9.8-10-9.7z","key":1})]);
}

ShareInline.defaultProps = {"fill":"#5f29c7","width":"61","height":"48"};

module.exports = ShareInline;

ShareInline.default = ShareInline;
